import script from "./AssigneeFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./AssigneeFilter.vue?vue&type=script&setup=true&lang=js"

import "./AssigneeFilter.vue?vue&type=style&index=0&id=888a5dce&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-888a5dce"]])

export default __exports__